import Header from "./components/Header"
import Main from "./pages/Main"
import Directories from "./pages/Directories"
import FilesProvider from "./fmanlibs/FilesProvider"
import SelectionProvider from "./fmanlibs/SelectionProvider"

export default function App(){
    return <>
        <Header/>
        <div className="body flex1 flex">
            <Directories/>
            <SelectionProvider><FilesProvider><Main/></FilesProvider></SelectionProvider>
        </div>
    </>
}